import { render, staticRenderFns } from "./swallowClickNumber.vue?vue&type=template&id=49beaec9&"
import script from "./swallowClickNumber.vue?vue&type=script&lang=js&"
export * from "./swallowClickNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('49beaec9')) {
      api.createRecord('49beaec9', component.options)
    } else {
      api.reload('49beaec9', component.options)
    }
    module.hot.accept("./swallowClickNumber.vue?vue&type=template&id=49beaec9&", function () {
      api.rerender('49beaec9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/datalist/swallowClickNumber.vue"
export default component.exports